    <template>
    <div>
        <transition name="fade" mode="out-in">
            <PasoUno
                v-show="paso1"
                :event="event"
                :zonas="zonas"
                :zonas_formated="zonas_formated"
                :loading_zonas="loading_zonas"
                :sesion_id="parseInt(sesion_id)"
                @setSvgGeneral="setSvgGeneral"
                @setZonasRA="setZonasRA"
                @terminar="finalizarPasoUno"
            />
        </transition>

        <transition name="fade" mode="out-in">
            <SelectorButacas
                v-if="paso2"
                :zona="zona"
                :zonas="zonas"
                :paso2_loading="paso2_loading"
                :paso3="paso3 || pasoProductos"
                :pasoExtraRA="pasoExtraRA"
                :loading="loading"
                :asientos="asientos"
                :event="event"
                :error_message="error_message"
                :asientos_maximos="asientos_maximos"
                :continuarConCompra="continuarConCompra"
                :configuracion="configuracion"
                :resetButacas="resetButacas"
                :bloquear_paso_butacas="bloquear_paso_butacas"
                @bloquearAsientos="bloquearAsientos"
                @closeModalAsientoOcupado="closeModalAsientoOcupado"
                @reset="reset"
                @cargado="() => paso2_loading = false"
                @bloquearButacas="bloquearButacas"
                @setAsientos="setAsientos"
                @setZona="(region) => zona = region"
                @continuarCompraSinNumerar="continuarCompraSinNumerar"
                @resetContinuarConCompra="continuarConCompra = false"
            />
        </transition>
        <VisibilidadReducida :zona="zona" @aceptar="AceptarVisibilidadReducida"/>
        <VisibilidadReducidaButaca :zona="zona" @aceptar="AceptarVisibilidadReducidaButaca"/>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="paso2_RA" ref="paso2_RA" id="paso2_RA">
                <SelectorAsientoComponent
                    :zona="zona"
                    :event="event"
                    :paso3="paso3"
                    :session_id="session_id"
                    :continuarConCompra="continuarConCompra"
                    :buttonCambiar="buttonCambiar"
                    :svgGeneral="svgGeneral"
                    :zonas="zonas"
                    :sesion_id="sesion_id"
                    @cambiarSector="cambiarSector"
                    @cambiar-asiento="cambiarAsiento"
                    @setSectores="setSectores"
                    @setPlazas="setPlazas"
                    @goTo="finalizarPasoDosRA"
                    @reset="reset"
                    @setCartId="(cart_id) => carrito_id = cart_id"
                />
                <div v-if="paso2_RA_loading" id="paso2_RA_loading" class="col-12 text-center pt-3 d-flex justify-content-center" style="height: 100vh;">
                    <LoaderComponent></LoaderComponent>
                </div>	
            </section>	
        </transition>

        <transition name="fade" mode="out-in">
            <PasoExtraRecintoAnexo
                v-if="pasoExtraRA && zonasRA.length > 0 && event.tiene_plazas_extra"
                key="pasoExtraRA"
                id="pasoExtraRA"
                :texto_producto_extra="event.texto_producto_extra"
                @continuarProductoExtra="continuarProductoExtra"
            />
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="pasoProductos" key="pasoProductos" id="pasoProductos" ref="pasoProductos">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <ListadoProductosComponent :carrito_id="carrito_id" :plazas="entradasPlazas" :asientos="asientos" :productos="productosListado" :desactivar="!pasoProductos_activo" @terminar="finalizarPasoProductos" @cambiar-asiento="cambiarAsiento" />
                        </div> 
                    </div>
                </div>
                <CarritoEvento 
                    :carrito_id="carrito_id" 
                    :plazas="entradasPlazas" 
                    :asientos="asientos"
                    :loading="loading" 
                    :productos="productos" 
                    :productosListado="productosListado"
                    :desactivar="!pasoProductos_activo" 
                    @terminar="finalizarPasoProductos" 
                    @cambiar-asiento="cambiarAsiento" 
                    :containerRef="containerRefs.pasoProductos"
                />
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content lightgray-content" v-if="paso3" key="paso3" id="paso3" ref="paso3">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <DatosCompradoresComponent
                                :reserva_instalaciones="event.reserva_instalaciones"
                                :datos_compradores="datos_compradores" 
                                :generos="generos" 
                                v-on:terminar="guardarDatos" 
                                :solicitar_datos="event.solicitar_datos" 
                                :productos="productos"
                                :asientos="asientos" 
                                :loading="loading"
                                :desactivar="!paso3_activo"
                                :lfp="event.lfp_id"
                                :plazas="entradasPlazas"
                                :limite_cambiar_datos_entrada="event.limite_tiempo_cambiar_nombre_entrada"
                                :limite_tiempo_cambiar_datos_entrada="event.limite_tiempo_format"
                                :fields="event.fields"
                                :event="event"
                                @cambiar-asiento="cambiarAsiento"
                                :errors="errors"
                            />
                        </div> 
                    </div>
                </div>
                <div v-if="paso3_loading" id="paso3_loading" class="col-12 d-flex justify-content-center" style="height: 100vh;">
                    <LoaderComponent></LoaderComponent>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="resumen" key="resumen" id="resumen">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.resumen_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('partido.revisa_datos') }}.</div>
                            <ResumenCompraComponent 
                                :entradas="asientos" 
                                :formulario="formulario" 
                                :voucher="voucher"
                                :event="event"
                                :datos="datos_compradores"
                                :productos="productos"
                                :session_id="session_id"
                                :entradasPlazas="entradasPlazas"
                                :sectores="sectores"
                                @terminar="guardarDatos" 
                                @terminado="procesarPago"
                                @volver="volverPasoTres()"
                                :desactivar="procesar_pago ? true : false"
                            >
                                <template slot="afterSummary">
                                    <CheckVoucherComponent 
                                        class="mb-5" 
                                        :event_id="event.id" 
                                        :event_session_id="sesion_id" 
                                        :cart_session_id="session_id" 
                                        :loading="loading"
                                        v-on:validated="setValidDiscountCode"
                                        :desactivar="procesar_pago ? true : false"
                                    ></CheckVoucherComponent>
                                </template>
                            </ResumenCompraComponent>				
                        </div>
                    </div>
                </div>
                <div v-if="resumen_loading" id="resumen_loading" class="col-12 text-center d-flex justify-content-center" style="height: 100vh;">
                    <LoaderComponent></LoaderComponent>
                </div>	
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content lightgray-content" v-if="procesar_pago" key="pago" id="pago">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                            <PagoPaycometComponent
                                ref="pago"
                                tipo_venta="evento"
                                :jet_id="jet_id"
                                :session_id="session_id"
                            />		
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
import DatosCompradoresComponent from '@/components/frontend/events/compra/DatosCompradoresComponent';
import ResumenCompraComponent from '@/components/frontend/events/compra/ResumenCompraComponent';
import CheckVoucherComponent from '@/components/frontend/events/compra/CheckVoucherComponent';
import Generos from "@/mixins/Generos";
import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';
import SelectorAsientoComponent from './components/recinto-anexo/SelectorAsientoComponent';
import PasoUno from './CompraConRecinto/PasoUno.vue';
import PasoExtraRecintoAnexo from './components/recinto-anexo/PasoExtraRecintoAnexo';
import VisibilidadReducida from '@/components/frontend/components/modals/VisibilidadReducida.vue';
import SelectorButacas from './CompraConRecinto/SelectorButacas.vue';
import VisibilidadReducidaButaca from '../../../backend/stepper/eventos/Modal/VisibilidadReducidaButaca.vue';
import ListadoProductosComponent from './components/productos/ListadoProductosComponent.vue';
import CarritoEvento from './components/CarritoEvento.vue';

export default {
    props: ['event', 'sesion_id', 'tiempoTerminado'],
    mixins: [Generos],
    data() {
        return {
            zonas: [],
            zona: null,
            asientos: [],
            paso1: true,
            paso2: false,
            pasoProductos: false,
            pasoProductos_activo: false,
            paso3: false,
            paso3_activo: false,
            resumen: false,
            solo_parking: false,
            loading: false,
            session_id: null,
            carrito_id:null,
            datos_compradores: {},
            formulario: null,
            asientos_maximos: this.event.n_max_asientos ?? 10,
            voucher: "",
            paso2_loading: false,
            pasoProductos_loading: false,
            paso3_loading: false,
            resumen_loading: false,
            procesar_pago: false,
            jet_id: null,
            paso2_RA: false,
            paso2_RA_loading: false,
            entradasPlazas: [],
            plazas_seleccionadas: false,
            pasoExtraRA: false,
            zonasRA: [],
            continuarConCompra: false,
            loading_zonas: true,
            error_message: '',
            sectores: null,
            buttonCambiar: true,
            svgGeneral: null,
            butacas: null,
            errors: null,
            resetButacas: 0,
            bloquear_paso_butacas: false,
            productos: [],
            productosListado: [],
            containerRefs: {
                pasoProductos: null,
            },
            carritoHeights: {
                pasoProductos: 0,
            },
        }
    },
    created() {
        this.iniciarCompra();

        switch (this.event.place.tipo_proceso_online) {
        case 1:
            this.getZonas();
            break;
        case 2:
            break;
        case 3:
            this.paso1 = false;
            this.paso2_loading = false;
            this.paso2 = true;
            break;
        default:
            break;
        }

    },
    beforeDestroy() {
        if (this.procesar_pago) {
            this.$refs.pago.clearAllIntervals();
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        zonas_formated() {
            var array = [];
            for(var zona in this.zonas) {
                array.push(this.zonas[zona]);
                var disponible = array[zona].precios.length > 0 && array[zona].esta_disponible && array[zona].libres > 0 ? true : false;
                array[zona].esta_disponible = disponible;
            }
            return array;                
        },
    },
    watch: {
        tiempoTerminado(tiempoTerminado) {
            if (tiempoTerminado) {
                this.recargar();
            }
        },
        pasoProductos(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    const container = this.$refs.pasoProductos;
                    if (container) {
                        this.containerRefs.pasoProductos = container;
                        const carrito = container.querySelector('.carrito-compras');
                        this.carritoHeights.pasoProductos = carrito ? carrito.offsetHeight : 0;
                    }
                });
            } else {
                this.containerRefs.pasoProductos = null;
                this.carritoHeights.pasoProductos = 0;
            }
        },
    },
    methods: {
        getZonas() {
            this.loading = true;
            this.loading_zonas = true;

            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro,
                    sesion_id: this.sesion_id,
                    evento_id: this.event.id,
                },
                sesion_id: this.sesion_id,
                evento_id: this.event.id,
            }

            this.$store.dispatch(this.config.getVuexAlias('front.zonas.index'), params).then(res => {
                this.zonas = res.data.data;
                this.getZonasRecintoAnexo();
            }).finally(() => {
                setTimeout(() => {
                    this.$scrollTo('#tabla-sectores', 600)
                }, 200);
                if (!this.event.recinto_anexo) {
                    this.loading = false;
                    this.loading_zonas = false;                    
                }
            });
        },
        getZonasRecintoAnexo() {
            this.loading = true;
            this.loading_zonas = true;
            let params = {
                filters: {
                    tid: this.configuracion.hash_teatro
                },
                evento_id: this.event.id,
                sesion_id: this.sesion_id
            }

            this.$store.dispatch(this.config.getVuexAlias('front.events.sesion.zonas.anexas'), params).then(({ data: {data} }) => {
                if(!this.solo_parking) {
                    this.zonas = this.zonas.concat(data);
                } else {
                    this.zonas.forEach(zona => {
                        if (zona.tipo_svg === "1") {
                            zona.esta_disponible = false;
                        }  
                    });  
                }
                this.zonasRA = data.filter(zona => zona.esta_disponible);

                const zonasDisponiblesNormales = this.zonas.filter(zona => zona.esta_disponible);
                const zonasDisponiblesAnexas = this.zonasRA;
                
                if (zonasDisponiblesNormales.length === 0 && zonasDisponiblesAnexas.length === 0) {
                    this.$router.push({ name: 'front.eventos.index' });
                }
                
                this.paso1 = true;

                this.buttonCambiar = true
            }).finally(() => {
                this.loading = false;
                this.loading_zonas = false;
            })
        },
        setZonasRA(zonas) {
            this.zonasRA = zonas;
        },
        async iniciarCompra() {
            await this.getGeneros();
        },
        reset(plazas = false) {
            this.asientos = [];
            this.datos_compradores = {};
            this.paso1 = true;
            
            if (plazas) {
                this.paso2_RA = false;
                this.paso2 = false;
                this.$nextTick(() => {
                    this.scrollTo('#paso1', 2000);
                })
            } else {
                if (this.event.place.tipo_proceso_online === 3) {
                    this.resetProcesoButacas();
                } else {
                    this.paso2 = false;
                }
                this.paso3 = false;
                this.$nextTick(function() {
                    this.scrollTo('#paso1', 2000);
                });
            }

            this.zona = null;
        },
        recargar() {
            if (this.procesar_pago) {
                this.$refs.pago.clearAllIntervals();
            }
            this.$emit('reset')
        },
        cambiarAsiento(plazas = false, productos = false) {
            if (productos) {
                this.pasoProductos = false;
                this.pasoProductos_activo = false;
                this.asientos = [];
                this.entradasPlazas = [];
                this.plazas_seleccionadas = false;
                this.productos = [];
                this.productosListado = [];
            } else {
                this.datos_compradores = {};
                this.paso3 = false;
                this.paso3_activo = false;
            }

            if (!productos) {
                if (this.event.tiene_productos) {
                    this.pasoProductos = true;
                    this.pasoProductos_activo = true;
                    this.paso2 = true;
                    this.$nextTick(function() {
                        this.scrollTo('#pasoProductos');
                    });
                    return;
                }
            }
            if (plazas) {
                this.entradasPlazas = [];
                this.productos = [];
                this.productosListado = [];
                this.paso2_RA = false;
                this.paso2_RA_loading = false;
                this.continuarConCompra = false;
                this.$nextTick(() => {
                    this.scrollTo('#paso1', 600);
                })

                this.getZonas();
            } else {
                if (this.event.place.tipo_proceso_online === 3 && !this.event.tiene_productos) {
                    this.resetProcesoButacas();                    
                } else {
                    this.paso2 = false;
                    this.paso2_loading = false;
                    this.asientos = [];
                    this.productos = [];
                    this.productosListado = [];
                    this.$nextTick(function() {
                        this.scrollTo('#paso2', 600);
                    });

                    this.getZonas();
                }
            }
        },
        finalizarPasoUno(zona) {
            this.zona = zona;
            if(zona.visibilidad_reducida){
                this.$modal.show('visibilidad-reducida');
            }
            this.paso1 = false;
            
            if (zona.tiene_recinto) {
                this.$nextTick(function() {
                    this.paso2_RA = true;
                    if(!this.zona.with_seats) {
                        this.paso2_RA_loading = false;
                    }
                });
            } else {
                this.paso2 = true;
                this.$nextTick(function() {
                    setTimeout(() => {
                        this.scrollTo('#paso2', 800);
                    }, 800);
                    if (!this.zona.with_seats) {
                        this.paso2_loading = false;
                    }
                });
            }
        },
        finalizarPasoDosRA(session_id) {
            this.plazas_seleccionadas = true;
            this.session_id = session_id;
            this.paso2_RA_loading = true;
            this.$nextTick(() => {
                this.scrollTo('#paso2_RA_loading');
            });
            this.$nextTick(() => {
                if(this.event.tiene_productos) {
                    this.pasoProductos = true;
                    this.pasoProductos_activo = true;
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.scrollTo('#pasoProductos');
                        });
                    }, 1000);
                } else {
                    this.paso3 = true;
                    this.paso3_activo = true;
                    this.$nextTick(() => {
                        this.scrollTo('#paso3');
                    });
                }
                this.paso2_RA_loading = false;
            });
        },
        finalizarPasoProductos() {
            this.loading = true;

            const tieneProductos = this.productosListado.length > 0 || (this.productos.length > 0 && this.productosListado.length > 0);
            let transformedProductos = [];

            if (!tieneProductos) {
                this.pasoProductos_activo = false;
                this.loading = false;
                this.paso3 = true;
                this.paso3_activo = true;
                this.$nextTick(() => this.scrollTo('#paso3'));
                return;
            }

            if (this.productos.length === 0 || this.productosListado.length === 0) {
                transformedProductos = this.productosListado.map(product => ({
                    teatro_product_id: product.item.id,
                    event_id: this.$route.params.event_id,
                    event_session_id: this.$route.params.sesion_id,
                    units: product.units,
                }));
            } else {
                this.productosListadoCombinacion();
                transformedProductos = this.productos.map(product => ({
                    teatro_product_id: product.item.id,
                    event_id: this.$route.params.event_id,
                    event_session_id: this.$route.params.sesion_id,
                    units: product.units,
                }));

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    },
                    cart_id: this.carrito_id,
                };

                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.productos.delete'), params);
            }

            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro,
                },
                cart_id: this.carrito_id,
                productos: transformedProductos,
            };

            this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.productos'), params)
                .then(() => {
                    this.pasoProductos_activo = false;
                    this.productosListadoCombinacion();
                    this.$nextTick(() => {
                        this.loading = false;
                        this.paso3 = true;
                        this.paso3_activo = true;
                        this.$nextTick(() => this.scrollTo('#paso3'));
                    });
                })
                .catch(error => {
                    console.error('Error al añadir productos al carrito:', error);
                });
        },
        productosListadoCombinacion() { 
            for (let index = 0; index < this.productosListado.length; index++) {
                const product = this.productosListado[index];
                if (this.productos.find(item => item.item.id === product.item.id)) {
                    this.productos.find(item => item.item.id === product.item.id).units += product.units;
                } else {
                    this.productos.push(product);
                }       
            }

            this.productosListado = [];
        },
        bloquearAsientos() {
            this.error_message = '';
            this.loading = true;
            this.paso2_loading= true
            this.$nextTick(function() {
                this.scrollTo('#paso2_loading', 1000);
            });
            var seats = [];

            for(var i in this.asientos) {
                seats.push(this.asientos[i].asiento);
            }

            const params = {
                filters: {
                    sesion_id: this.sesion_id,
                    tid: this.configuracion.hash_teatro
                },
                zona_id: this.zona.id,
                asientos: seats,
                tid: this.configuracion.hash_teatro
            }

            this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                if(res.data.error) {
                    this.$toast.error(res.data.message);
                    this.getZonas();
                    this.reset();

                } else {
                    if (! this.plazas_seleccionadas && this.zonasRA.length > 0 && this.event.tiene_plazas_extra) {
                        this.pasoExtraRA = true;
                        this.paso2_loading= false;
                        this.$nextTick(() => {
                            this.$scrollTo('#pasoExtraRA', 1000);
                        });
                    } else {
                        if(this.event.tiene_productos) {
                            this.pasoProductos = true;
                            this.pasoProductos_activo = true;
                            this.$nextTick(() => {
                                this.scrollTo('#pasoProductos');
                            });
                        } else {
                            this.paso3 = true;
                            this.paso3_activo = true;
                            this.$nextTick(() => {
                                this.scrollTo('#paso3');
                            });
                        }
                        this.paso2_loading = false
                    }

                    this.session_id = res.data.session_id;
                    this.carrito_id = res.data.cart_id;
                    sessionStorage.setItem('session_id', this.session_id);
                    this.loading = false;
                }                    
            }).catch(error => {
                var message = error.response.data.message;
                if(message === 'No existe precio para socios en el área indicada para este partido.' || 
                message === 'Error interno del sistema. Este código corresponde a errores de coherencia internos del sistema de la LFP.'||
                message === 'Se ha recibido un código PIN incorrecto.'){
                    this.error_message = message;
                }else {
                    this.showModal('asiento-ocupado');
                }
                this.loading = false;
            });
        },
        bloquearButacas(butacasSeleccionadas) {
            this.loading = true;
            this.paso2_loading= true
            butacasSeleccionadas.forEach(butaca => {
                butaca.precio = butaca.precioSeleccionado;
            });
            
            this.asientos = butacasSeleccionadas;
            const data = butacasSeleccionadas.map(butaca => {
                return {
                    'butaca_id': butaca.id,
                    'precio_id': butaca.precioSeleccionado.id
                }
            });

            const params = {
                filters: {},
                event_id: this.$route.params.event_id,
                sesion_id: this.$route.params.sesion_id,
                session_id: this.session_id,
                data: data
            };

            this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.bloquear-butacas'), params).then(res => {
                this.session_id = res.data.session_id;
                this.carrito_id = res.data.cart_id;
                this.bloquear_paso_butacas = true;
                this.$nextTick(function() {
                    this.scrollTo('#paso2_loading');
                });
                setTimeout(() => {
                    if(this.event.tiene_productos) {
                        this.pasoProductos = true;
                        this.pasoProductos_activo = true;
                        this.$nextTick(() => {
                            this.scrollTo('#pasoProductos');
                        });
                    } else {
                        this.paso3 = true;
                        this.paso3_activo = true;
                        this.$nextTick(function() {
                            this.scrollTo('#paso3');
                        });
                    }
                    this.paso2_loading= false;
                    this.loading = false;
                }, 2000); 

                sessionStorage.setItem('session_id', this.session_id);

            }).catch(error => {
                if (error?.response?.data?.message) {
                    this.$toast.error('Butaca/s ocupada/s');
                    this.resetProcesoButacas();
                    console.error('Butacas ocupadas');
                } else {
                    console.error('Error al bloquear las butacas');
                }
            })
        },
        guardarDatos() {
            this.loading = true;
            this.datos_compradores.asientos = this.asientos;
            this.datos_compradores.entradasPlazas = this.entradasPlazas;

            const params = {
                filters: {
                    sesion_id: this.sesion_id,
                    tid: this.configuracion.hash_teatro
                },
                datos_compradores: this.datos_compradores,
                session_id: this.session_id,
                tid: this.configuracion.hash_teatro
            }	
            this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador'), params).then(res => {
                this.jet_id = res.data.jet_id;
                this.formulario = res.data.formulario;
                this.datos_compradores = res.data.datos_compradores[0];
                this.asientos = res.data.datos_compradores[0].asientos;
                if(this.datos_compradores['voucher']) {
                    this.voucher = this.datos_compradores['voucher'];
                }
                if (this.plazas_seleccionadas) {
                    this.formatPlazasResumen();
                }
                if(this.datos_compradores.privacidad)return
                this.paso3_loading = true;
                this.$nextTick(function() {
                    this.scrollTo('#paso3_loading');
                });
                this.paso3_activo = false;
                setTimeout(() => {
                    this.resumen = true;
                    this.paso3_loading = false;
                    this.$nextTick(function() {
                        this.scrollTo('#resumen');
                    });
                }, 2000); 
            }).catch(error => {
                if (error.response.data.message == 'Campos requeridos') {
                    this.errors = error.response.data.errors;
                } else {
                    this.$toast.error(error.response?.data?.message);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        scrollTo(paso) {
            this.$scrollTo(paso, 100)
        },
        setValidDiscountCode(voucher) {
            this.datos_compradores.voucher = voucher;
            this.voucher = voucher;
            this.guardarDatos();
        },
        close() {
            this.$emit('close', 'imagen-panoramica');
        },
        closeModalAsientoOcupado() {
            this.$modal.hide('asiento-ocupado');
            this.asientos = [];
            this.getZonas();
            this.scrollTo('#paso1')
        },
        showModal(modal)  {
            this.$modal.show(modal)
        },
        procesarPago(precio_cero = false) {
            this.resumen_loading = true;
            if (precio_cero) {
                this.procesarCompraPrecioCero();
            } else {
                this.$nextTick(() => {
                    this.scrollTo('#resumen_loading');
                });
                setTimeout(() => {
                    this.procesar_pago = true;
                    this.resumen_loading = false;
                    this.$nextTick(() => {
                        this.scrollTo('#pago');
                    });
                }, 2000); 
            }

        },
        procesarCompraPrecioCero() {
            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro
                },
                carrito_id: this.session_id
            }

            this.$store.dispatch(this.config.getVuexAlias('front.events.procesar-compra-precio-cero'), params).then(res => {
                this.$router.push(`/compra/${this.session_id}/${res.data.n_pedido}`);
            }).finally(() => this.loading = false);
        },
        setPlazas(plazas) {
            this.entradasPlazas = plazas;
            this.continuarConCompra = true;
        },
        continuarProductoExtra(add) {
            if (add) {
                if (this.zonasRA.length === 1) {
                    this.paso2 = false;
                    this.paso2_RA_loading = true;
                    this.$nextTick(() => {
                        this.finalizarPasoUno(this.zonasRA[0]);
                    });
                } else if (this.zonasRA.length > 1) {
                    this.solo_parking = true;
                    this.getZonasRecintoAnexo();
                    this.paso1 = true;
                    this.paso2 = false;
                    this.$nextTick(() => {
                        this.scrollTo('#paso1', 1000);
                    });
                }
            } else {
                if (this.event.tiene_productos) {
                    this.pasoProductos = true;
                    this.pasoProductos_activo = true;
                    this.$nextTick(function() {
                        this.scrollTo('#pasoProductos');
                    });
                } else {
                    this.paso3 = true;
                    this.paso3_activo = true;
                    this.$nextTick(function() {
                        this.scrollTo('#paso3', 1000);
                    });
                }
            }
            
            this.pasoExtraRA = false;
        },
        formatPlazasResumen() {
            this.entradasPlazas.map(plaza => {
                return {
                    ...plaza.precioSeleccionado,
                    nombrePlaza: plaza.name,
                    sector: plaza.sector,
                    fila: plaza.fila,
                    butaca: plaza.butaca,
                    price_management_interno: plaza.precioSeleccionado.price_management_interno,
                    price_management_online: plaza.precioSeleccionado.price_management_online
                }
            });
        },
        volverPasoTres() {
            this.resumen = false;
            this.paso3_activo = true;
            this.$nextTick(function() {
                this.scrollTo('#paso3');
            });
        },
        AceptarVisibilidadReducida(){
            this.$modal.hide('visibilidad-reducida');
        },
        AceptarVisibilidadReducidaButaca(){
            this.$modal.hide('visibilidad-reducida-butaca');
        },
        setSectores(sectores) {
            this.sectores = sectores;
        },
        setSvgGeneral(svgGeneral) {
            this.svgGeneral = svgGeneral;
        },
        cambiarSector(sector) {
            this.paso2_RA = false;
            this.finalizarPasoUno(sector);
        },
        setAsientos(asientos) {
            this.asientos = asientos;
        },
        resetProcesoButacas() {
            this.paso1 = false;
            this.paso2 = true;
            this.resetButacas++;
            this.bloquear_paso_butacas = false;
            this.$nextTick(() => {
                this.$scrollTo('#paso2', 1000);
            });
        },
        continuarCompraSinNumerar(asientos) {
            this.continuarConCompra = true;
            this.asientos = asientos;
            this.zona = this.asientos[0]?.zonaSeleccionada;
            this.$nextTick(() => {
                this.bloquearAsientos();
            });
        }
    },
    components: {
        DatosCompradoresComponent, ResumenCompraComponent, CheckVoucherComponent, PagoPaycometComponent,
        SelectorAsientoComponent, PasoUno, PasoExtraRecintoAnexo, VisibilidadReducida, SelectorButacas,
        VisibilidadReducidaButaca, ListadoProductosComponent, CarritoEvento
    }
}
</script>

    <style>
        .fade-enter-active, .fade-leave-active {
            transition: opacity .2s;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }

        #atras_button {
            position: absolute;
            height: 48.5px;
            left: 14em; 
            bottom: 0
        }

        @media (max-width: 600px) {
            #atras_button {
                min-width: 175px;
                height: 52px;
                margin-left: 3px;
                font-size: 14px;
            }
        }
        
        @media (min-width: 1000px) {
            br {
                display: none
            }
        }
    </style>
